import { WppInlineMessage, WppLabel, WppTextareaInput } from '@wppopen/components-library-react'
import clsx from 'clsx'
import type { WppTextareaInputCustomEvent } from '@wppopen/components-library/dist/types/components'
import type { TextareaInputChangeEventDetail } from '@wppopen/components-library'
import styles from './TextAreaWithIcon.module.scss'

interface TextAreaWithIconProps {
  value: string
  id: string
  label: string

  renderInputIcon?: JSX.Element
  disabled?: boolean
  onWppChange?: (event: WppTextareaInputCustomEvent<TextareaInputChangeEventDetail>) => void

  isMessageVisible?: boolean
  messageType?: 'warning' | 'error'
  message?: string
}

export default function TextAreaWithIcon({
  value,
  id,
  label,
  renderInputIcon,
  disabled,
  onWppChange,
  isMessageVisible,
  messageType,
  message,
}: TextAreaWithIconProps) {
  return (
    <fieldset
      data-testid="text-area-with-icon"
      className={clsx(
        styles.textArea,
        messageType === 'warning' ? styles.warning : undefined,
        messageType === 'error' ? styles.error : undefined,
        disabled ? styles.disabled : undefined,
      )}
    >
      <WppLabel
        config={{ text: label }}
        typography="s-strong"
        disabled={disabled}
        data-testid="text-area-with-icon-label"
      />
      <div className={styles.textareaContainer}>
        <WppTextareaInput
          data-testid="text-area-input"
          required
          id={id}
          value={value}
          disabled={disabled}
          onWppChange={onWppChange}
          rows={1}
        />
        {renderInputIcon}
      </div>

      {isMessageVisible && (
        <WppInlineMessage
          data-testid="text-area-inline-message"
          size="s"
          showTooltipFrom={200}
          type={messageType}
          message={message}
        />
      )}
    </fieldset>
  )
}
